import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import FormFieldsTable from "../../components/forms/FormFieldsTable";
import DateInputField from "../../components/forms/DateInputField";
import FormError from "../../components/forms/FormError";

class RestartSubscriptionForm extends Component {

  render() {
    let {errors, handleSubmit, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 

    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <p>Make sure that the quantities, frequency and shipping address is correct before restarting the subscription. Please note that the requested delivery date might not be available, in such case the nearest available date will be picked.</p>
          <FormFieldsTable>
            <Field
              label="Delivery Date"
              name="deliveryDate"
              placeholder=""
              showDatePicker={this.props.showDatePicker}
              component={DateInputField}
              serverError={this.props.errors.deliveryDate}
              />
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton onClick={handleSubmit(values => this.props.onSubmit(values))} label={submitLabel} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "RestartSubscriptionForm"
})(RestartSubscriptionForm);

export default ReduxForm;